import { createStore } from 'vuex'
import axios from 'axios'
import router from '@/router'

// 配置axios
axios.defaults.baseURL = '/api'
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default createStore({
  state: {
    token: localStorage.getItem('token') || null,
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    isLoggedIn: !!localStorage.getItem('token')
  },
  
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      state.isLoggedIn = !!token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      if (userInfo && Object.keys(userInfo).length > 0) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      } else {
        localStorage.removeItem('userInfo')
      }
    },
    
    SET_LOGIN_STATE(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
    },
    
    CLEAR_AUTH(state) {
      state.token = null
      state.userInfo = {}
      state.isLoggedIn = false
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await axios.post('/auth/login', credentials)
        const { token, user } = response.data
        
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', user)
        commit('SET_LOGIN_STATE', true)
        
        return { success: true }
      } catch (error) {
        return { 
          success: false, 
          message: error.response?.data?.message || '登录失败' 
        }
      }
    },
    
    async checkAuth({ commit, state }) {
      if (!state.token) {
        commit('SET_LOGIN_STATE', false)
        return false
      }
      
      try {
        // 验证token是否有效，并获取最新的用户信息
        const response = await axios.get('/auth/me')
        const user = response.data.user
        
        commit('SET_USER_INFO', user)
        commit('SET_LOGIN_STATE', true)
        return true
      } catch (error) {
        // token无效，清除本地存储
        commit('SET_TOKEN', null)
        commit('SET_USER_INFO', {})
        commit('SET_LOGIN_STATE', false)
        return false
      }
    },
    
    logout({ commit }) {
      commit('CLEAR_AUTH')
      router.push('/login')
    }
  },
  
  getters: {
    isAdmin: state => state.userInfo.is_admin || false
  }
}) 